// function that returns a random number between a min and max
export const getRandomNumber = (min, max) => {
  return Math.ceil(Math.random() * (max - min) + min)
}

let starLeftPos
let starBottomPos

function randomStarPositions() {
  starLeftPos = `${getRandomNumber(1, 99)}%`
  starBottomPos = `${getRandomNumber(1, 99)}%`
}

export const createStars = (type, quantity) => {
  const starPositionArray = []
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < quantity; i++) {
    const star = document.createElement('div')
    star.classList.add('star', `type-${type}`)

    randomStarPositions()
    const starPositionCoordinates = [starLeftPos, starBottomPos]
    if (starPositionArray.includes(starPositionCoordinates === true)) {
      randomStarPositions()
    } else {
      starPositionArray.push(starPositionCoordinates)
      star.style.left = starLeftPos
      star.style.bottom = starBottomPos
    }

    star.style.animationDuration = `${getRandomNumber(50, 200)}s`
    // document.body.appendChild(star);
    document.getElementById('galaxy').appendChild(star)
  }
}

// export const createStarsLong = (type, quantity) =>{
//   for(let i = 0; i < quantity; i++){
//     const star = document.createElement('div');
//     star.classList.add('star', `type-${type}`);
//     star.style.left = `${getRandomNumber(1, 99)}%`;
//     star.style.bottom = `${getRandomNumber(1, 1000)}%`;
//     star.style.animationDuration = `${getRandomNumber(50, 200)}s`;
//     // document.body.appendChild(star);
//     document.getElementById('universe').appendChild(star)
//   }
// }

// export const createStarsLong = (type, quantity) =>{
//   for(let i = 0; i < quantity; i++){
//     const star = document.createElement('div');
//     star.classList.add('star', `type-${type}`);
//     star.style.left = `${getRandomNumber(1, 99)}%`;
//     star.style.bottom = `${getRandomNumber(1, 99)}%`;
//     star.style.animationDuration = `${getRandomNumber(50, 200)}s`;
//     document.querySelector('.universe').appendChild(star);
//   }
// }
